import configs from "../configs";

const { useRef, useEffect } = require("react");

export function useOutsideAlerter(onClick, isSelector) {
  const ref = useRef();
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        (isSelector
          ? true
          : !document
              .getElementById(configs.SELECTOR_PORTAL_KEY)
              .contains(event.target))
      ) {
        onClick();
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onClick, isSelector]);
  return [ref];
}
